export const Data = [
  {
    id: 1,
    day: 1,
    weak: 1,
    year: 2016,
    userGain: 22,
    userLost: 11,
  },
  {
    id: 2,
    day: 2,
    weak: 2,
    year: 2017,
    userGain: 32,
    userLost: 11,
  },
  {
    id: 3,
    day: 3,
    weak: 3,
    year: 2018,
    userGain: 12,
    userLost: 12,
  },
  {
    id: 4,
    day: 4,
    weak: 4,
    year: 2019,
    userGain: 34,
    userLost: 22,
  },
  {
    id: 5,
    day: 5,
    weak: 5,
    year: 2020,
    userGain: 11,
    userLost: 20,
  },
  {
    id: 6,
    day: 6,
    weak: 6,
    year: 2019,
    userGain: 44,
    userLost: 11,
  },
  {
    id: 7,
    day: 7,
    weak: 7,
    year: 2020,
    userGain: 32,
    userLost: 9,
  },
];

export const dataOffice = [
  {
    id: 1,
    day: 1,
    weak: 1,
    year: 2016,
    userGain: 21,
    userLost: 22,
  },
  {
    id: 2,
    day: 2,
    weak: 2,
    year: 2017,
    userGain: 23,
    userLost: 24,
  },
  {
    id: 3,
    day: 3,
    weak: 3,
    year: 2018,
    userGain: 25,
    userLost: 26,
  },
  {
    id: 4,
    day: 4,
    weak: 4,
    year: 2019,
    userGain: 27,
    userLost: 28,
  },
  {
    id: 5,
    day: 5,
    weak: 5,
    year: 2020,
    userGain: 29,
    userLost: 30,
  },
  {
    id: 6,
    day: 6,
    weak: 6,
    year: 2019,
    userGain: 31,
    userLost: 32,
  },
  {
    id: 7,
    day: 7,
    weak: 7,
    year: 2020,
    userGain: 33,
    userLost: 34,
  },
];

export const dataMeetings = [
  {
    id: 1,
    day: 1,
    weak: 1,
    year: 2016,
    userGain: 22,
    userLost: 24,
  },
  {
    id: 2,
    day: 2,
    weak: 2,
    year: 2017,
    userGain: 51,
    userLost: 21,
  },
  {
    id: 3,
    day: 3,
    weak: 3,
    year: 2018,
    userGain: 24,
    userLost: 12,
  },
  {
    id: 4,
    day: 4,
    weak: 4,
    year: 2019,
    userGain: 66,
    userLost: 2,
  },
  {
    id: 5,
    day: 5,
    weak: 5,
    year: 2020,
    userGain: 11,
    userLost: 22,
  },
  {
    id: 6,
    day: 6,
    weak: 6,
    year: 2019,
    userGain: 11,
    userLost: 55,
  },
  {
    id: 7,
    day: 7,
    weak: 7,
    year: 2020,
    userGain: 333,
    userLost: 369,
  },
];
